export enum InterfaceNames {
    IPageConfigurationProvider = "IPageConfigurationProvider",
};